<template>
  <LayoutDashboard title="Relatório de vendas">
    <v-card
      outlined
      v-if="$helper.verificaPermissao('visualizar-relatorio-comissao')"
    >
      <v-card-title>Comissão por período.</v-card-title>
      <v-form class="px-3" ref="formRelatorioComissao">
        <v-card-text>
          <v-layout wrap row>
            <v-flex xs12 md4>
              <v-autocomplete
                :items="getFuncionarios"
                v-model="dadosRelatorioComissao.funcionario_id"
                item-text="nome_abreviado"
                item-value="id"
                class="mr-2 ml-2"
                label="Funcionário"
                outlined
                dense
                :rules="rules.funcionario_id_relatorio_comissao"

              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                label="Período Inicial"
                type="date"
                class="mr-2 ml-2"
                v-model="dadosRelatorioComissao.periodo_inicial"
                :rules="rules.periodo_inicial_relatorio_comissao"
                outlined
                dense
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                label="Período Final"
                type="date"
                class="mr-2 ml-2"
                v-model="dadosRelatorioComissao.periodo_final"
                :rules="rules.perido_final_relatorio_comissao"
                outlined
                dense
                append-outer-icon="print"
                @click:append-outer="_gerarRelatorioComissao()"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
    </v-card>
    <v-card
      outlined
      v-if="$helper.verificaPermissao('visualizar-relatorio-comissao')"
      class="mt-2"
    >
      <v-card-title>Venda por período.</v-card-title>
      <v-form class="px-3" ref="formRelatorioVenda">
        <v-card-text>
          <v-layout wrap row>
            <v-flex xs12 md4>
              <v-select
                :items="['', ...getFormasPagamento]"
                item-text="nome"
                item-value="id"
                v-model="dadosRelatorioVenda.formaPagamentoId"
                label="Forma de Pagamento"
                outlined
                dense
                class="mr-2 ml-2"
              ></v-select>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                label="Período Inicial"
                type="date"
                class="mr-2 ml-2"
                v-model="dadosRelatorioVenda.periodo_inicial"
                :rules="rules.periodo_inicial_relatorio_venda"
                outlined
                dense
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                label="Período Final"
                type="date"
                class="mr-2 ml-2"
                v-model="dadosRelatorioVenda.periodo_final"
                :rules="rules.perido_final_relatorio_venda"
                outlined
                dense
                append-outer-icon="print"
                @click:append-outer="_gerarRelatorioVenda()"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
    </v-card>
    <v-card outlined class="mt-2">
      <v-card-title>Produtos vendidos.</v-card-title>
      <v-form class="px-3" ref="formRelatorioProdutosVendidos">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 md4>
              <v-autocomplete
                label="Produto"
                :items="['', ...getProdutos]"
                item-text="descricao"
                item-value="id"
                v-model="dadosRelatorioProdutosVendidos.produto_id"
                class="mr-2 ml-2"
                outlined
                dense
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md2>
              <v-text-field
                label="Perído inicial"
                type="date"
                class="mr-2 ml-2"
                v-model="dadosRelatorioProdutosVendidos.periodo_inicial"
                outlined
                dense
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md2>
              <v-text-field
                label="Perído final"
                type="date"
                class="mr-2 ml-2"
                v-model="dadosRelatorioProdutosVendidos.periodo_final"
                outlined
                dense
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md2>
              <v-autocomplete
                :items="['', ...getGruposProduto]"
                item-text="grupo"
                item-value="id"
                v-model="dadosRelatorioProdutosVendidos.grupoId"
                label="Grupo"
                class="mr-2 ml-2"
                outlined
                dense
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md2>
              <v-autocomplete
                label="Marca"
                :items="['', ...getMarcas]"
                item-text="marca"
                item-value="marca"
                v-model="dadosRelatorioProdutosVendidos.marca"
                class="mr-2 ml-2"
                outlined
                dense
                append-outer-icon="print"
                @click:append-outer="_gerarRelatorioProdutosVendidos()"
              ></v-autocomplete>
            </v-flex>
            
          </v-layout>
        </v-card-text>
      </v-form>
    </v-card>
  </LayoutDashboard>
</template>
<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["getMarcas", "getProdutos", "getFormasPagamento", "getFuncionarios", "getGruposProduto"]),
  },
  data() {
    return {
      dadosRelatorioComissao: {
        periodo_inicial: moment().format("YYYY-MM-DD"),
        periodo_final: moment().format("YYYY-MM-DD"),
      },
      dadosRelatorioVenda: {
        periodo_inicial: moment().format("YYYY-MM-DD"),
        periodo_final: moment().format("YYYY-MM-DD"),
      },
      dadosRelatorioProdutosVendidos: {
        periodo_inicial: moment().format("YYYY-MM-DD"),
        periodo_final: moment().format("YYYY-MM-DD"),
        marca: "",
        produto_id: "",
        grupoId: "",
      },
      rules: {
        periodo_inicial_relatorio_comissao: [
          (v) => !!v || "Campo obrigatório.",
        ],
        perido_final_relatorio_comissao: [(v) => !!v || "Campo obrigatório."],
        periodo_inicial_relatorio_venda: [(v) => !!v || "Campo obrigatório."],
        funcionario_id_relatorio_comissao: [(v) => !!v || "Campo obrigatório."],
        perido_final_relatorio_venda: [(v) => !!v || "Campo obrigatório."],
        forma_pagamento_relatorio_venda: [(v) => !!v || "Campo obrigatório."],
        periodo_inicial_relatorio_produtos_vendidos: [
          (v) => !!v || "Campo obrigatório.",
        ],
        periodo_final_relatorio_produtos_vendidos: [
          (v) => !!v || "Campo obrigatório.",
        ],
      },
    };
  },
  methods: {
    ...mapActions([
      "gerarRelatorioComissao",
      "gerarRelatorioVenda",
      "listarMarcas",
      "gerarRelatorioProdutoVendido",
      "listarProdutos",
      "listarFormaPagamento",
      "listarFuncionarios",
      "listarGruposProduto"
    ]),
    _gerarRelatorioComissao() {
      if (this.$refs.formRelatorioComissao.validate()) {
        this.gerarRelatorioComissao(this.dadosRelatorioComissao);
      }
    },
    _gerarRelatorioVenda() {
      if (this.$refs.formRelatorioVenda.validate()) {
        this.gerarRelatorioVenda(this.dadosRelatorioVenda);
      }
    },
    _gerarRelatorioProdutosVendidos() {
      if (this.$refs.formRelatorioProdutosVendidos.validate()) {
        this.gerarRelatorioProdutoVendido(this.dadosRelatorioProdutosVendidos);
      }
    },
  },
  created() {
    this.listarMarcas();
    this.listarProdutos({});
    this.listarFormaPagamento();
    this.listarFuncionarios()
    this.listarGruposProduto()
  },
};
</script>
